module.exports = require("./lrc.d.ts");